var _dec, _class;

import { model, Model, prop } from "mobx-keystone";
export let PixelPositionModel = (_dec = model("resources/PixelPositionModel"), _dec(_class = class PixelPositionModel extends Model({
  x: prop(0).withSetter(),
  y: prop(0).withSetter()
}) {}) || _class);